module.exports = __webpack_public_path__ + "static/media/024.d1ca04c2.jpg";